import classNames from 'classnames';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties/ContextProviderNode';
import { EditorChildren } from './EditorChildren';
import { getKeyFromPath } from '../utils/ProviderNodeUtils';
import './EditorCategoryContents.less';

interface IEditorCategoryContentsProps {
  child: ContextProviderNode;
  path: string[];
  depth: number;
  name: string;
  usePopupEditor?: boolean;
  className?: string;
  renderHidden?: boolean;
}

const getContentsClass = (usePopupEditor = false, renderHidden = false) =>
  classNames('dpc-editor-category-contents', {
    'dpc-editor-category-contents--in-popup': usePopupEditor,
    'dpc-editor-category-contents--hidden': renderHidden,
  });

/**
 * Content component for Editor Category, mostly to DRY up and simplify it's parent.
 *
 * Copyright (c) 2019 Decisions All Rights Reserved
 */
export function EditorCategoryContents({
  child,
  name,
  path,
  depth,
  renderHidden,
  usePopupEditor,
}: IEditorCategoryContentsProps) {
  return (
    <div className={getContentsClass(usePopupEditor, renderHidden)}>
      <EditorChildren
        nodes={child.Children}
        depth={depth + 1}
        path={[...path, name]}
        key={getKeyFromPath(path, child)}
      />
    </div>
  );
}
